import { Divider, Stack, Switch, Typography } from '@mui/material';
import { useState } from 'react';

import type { BackupVault } from '@/data/vaults/backupVault';

import { KMSKeyEditorPanel } from './kmsKeyEditorPanel';

import { Accordion, AccordionDetails, AccordionSummary } from '../accordion';
import { ChangeableTextField } from '../text/changeableTextField';

export const VaultAdvanceOptions = ({
  disabled,
  data,
  setData,
  customKey,
  setCustomKey,
}: {
  disabled: boolean;
  data: BackupVault;
  setData: (data: BackupVault) => void;
  customKey: boolean;
  setCustomKey: (customKey: boolean) => void;
}) => {
  return (
    <Stack gap='12px'>
      <Divider sx={{ margin: '0 -40px' }} />
      <Accordion>
        <AccordionSummary>
          <Typography variant='h4'>Advanced options</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingRight: '0' }}>
          <Stack
            gap='16px'
            divider={<Divider sx={{ borderStyle: 'dashed' }} />}
          >
            <KmsKeyOption
              disabled={disabled}
              data={data}
              setData={setData}
              customKey={customKey}
              setCustomKey={setCustomKey}
            />
          </Stack>
        </AccordionDetails>
      </Accordion>
      <Divider sx={{ margin: '0 -40px' }} />
    </Stack>
  );
};

const KmsKeyOption = ({
  disabled,
  data,
  setData,
  customKey,
  setCustomKey,
}: {
  disabled: boolean;
  data: BackupVault;
  setData: (data: BackupVault) => void;
  customKey: boolean;
  setCustomKey: (customKey: boolean) => void;
}) => {
  const [openKmsKeyEditor, setOpenKmsKeyEditor] = useState(false);

  return (
    <Stack className='w-full' gap='24px'>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Stack direction='row' gap='12px' alignItems='center'>
          <Switch
            size='small'
            disabled={disabled}
            checked={customKey}
            onChange={(event) => {
              setCustomKey(event.target.checked);
              if (!event.target.checked) {
                setData({
                  ...data,
                  vaultAttributes: {
                    ...data.vaultAttributes,
                    aws: {
                      ...data.vaultAttributes.aws,
                      encryptionKey: '',
                    },
                  },
                });
              }
            }}
          />
          <Typography>{`Use my own KMS key`}</Typography>
        </Stack>
        {customKey && (
          <Stack width='400px' justifyContent='flex-end'>
            <ChangeableTextField
              value={data.vaultAttributes.aws?.encryptionKey}
              onClick={() => setOpenKmsKeyEditor(true)}
              placeholder='No key set'
              noValueButtonText='Set Key'
            />
          </Stack>
        )}
        <KMSKeyEditorPanel
          open={openKmsKeyEditor}
          onClose={() => setOpenKmsKeyEditor(false)}
          disabled={disabled}
          data={data}
          setData={setData}
        />
      </Stack>
    </Stack>
  );
};
